import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Card } from "react-bootstrap";

import { useTheme } from "hooks";
import ToolTip from "components/ToolTip/ToolTip";
import IconButton from "components/IconButton/IconButton";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import { SvgComponent } from "components/SvgComponent/SvgComponent";
import useQueryParams from "hooks/useQueryParams";

function EditHeader(props) {
  const { theme } = useTheme();
  const history = useHistory();
  const URLParameters = useQueryParams();
  const Id = URLParameters.get("Id");

  useEffect(() => {
    window.addEventListener("keydown", onEvent);
    return () => {
      window.removeEventListener("keydown", onEvent);
    };
  });

  function onEvent(e) {
    if ((e.metaKey || e.ctrlKey) && e.code === "KeyS") {
      if (props.grabar) {
        e.preventDefault();
        props.grabar();
      }
    }
  }

  function back() {
    history.goBack();
  }

  return (
    <div
      style={{
        position: `sticky`,
        top: !props.isInSimpleBar ? "48px" : "0px",
        zIndex: 200,
        display: props.esModal ? "none" : "",
        maxHeight: "50px",
      }}
    >
      <Card.Header
        style={{
          background: "white",
          padding: "0.3em 1em 0.3em 1em",
          borderBottom: "1px solid  #e3e3e3",
        }}
      >
        <div className="d-flex justify-content-between">
          <div
            className=" d-flex w-50 align-content-center"
            style={{
              alignSelf: "center",
              alignItems: "center",
            }}
          >
            {props.volver && !props.esView && (
              <IconButton onClick={props.volverFunc ?? back}>
                <ToolTip message="Volver">
                  <div>
                    <SvgComponent width="30" height="30" iconName="back" />
                  </div>
                </ToolTip>
              </IconButton>
            )}
            <Card.Title as="h4" className="d-inline font-weight-bold">
              {props.titulo + (Id && !props.hideIdSec ? ` (Id: ${Id})` : "")}
            </Card.Title>
          </div>
          <div className="d-flex w-25 justify-content-end">
            {props.generarCuenta && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="id-card"
                message="Generar Cuenta"
                onClick={props.generarCuenta}
              />
            )}
            {props.nuevoDetalle && (
              <IconButton onClick={props.nuevoDetalle}>
                <ToolTip message="Nuevo Detalle">
                  <i
                    style={{
                      fontSize: "30px",
                      color: `${theme.color1}`,
                    }}
                    className="fa-solid fa-file-circle-plus"
                  ></i>
                </ToolTip>
              </IconButton>
            )}
            {props.descargarPlantillas && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="download"
                message="Descargar Plantillas"
                onClick={props.descargarPlantillas}
              />
            )}
            {props.enviarCredenciales && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="send"
                message="Enviar Credenciales"
                onClick={props.enviarCredenciales}
              />
            )}
            {props.inactivar && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="cancel"
                message="Inactivar"
                onClick={props.inactivar}
              />
            )}
            {props.rechazar && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="cancel"
                message="Rechazar"
                onClick={props.rechazar}
              />
            )}
            {props.cambioPassword && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="lock"
                message="Cambiar Contraseña"
                onClick={props.cambioPassword}
              />
            )}

            {props.iniciarLlamada && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="call"
                message="Iniciar Llamada"
                onClick={props.iniciarLlamada}
              />
            )}
            {props.concluirLlamada && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="close-call"
                message="Concluir Llamada"
                onClick={props.concluirLlamada}
              />
            )}
            {props.copiarToken && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="copy"
                message="Copiar Token"
                onClick={props.copiarToken}
              />
            )}
            {props.generarToken && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="create"
                message="Generar Nuevo Token"
                onClick={props.generarToken}
              />
            )}
            {props.adjuntarDocumento && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="attachment"
                message="Documentos adjuntos"
                onClick={props.adjuntarDocumento}
              />
            )}
            {props.crearEnProduccion && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="create"
                message="Crear en Producción"
                onClick={props.crearEnProduccion}
              />
            )}
            {props.clean && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="clean"
                message="Limpiar"
                onClick={props.clean}
              />
            )}
            {props.imprimirRepresentacion && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="print"
                message="Representación Impresa"
                onClick={props.imprimirRepresentacion}
              />
            )}
            {props.descargarArchivoXML && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="download"
                message="Archivo XML"
                onClick={props.descargarArchivoXML}
              />
            )}
            {props.descargarArchivoRespuestaXML && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="download"
                message="Archivo Respuesta XML"
                onClick={props.descargarArchivoRespuestaXML}
              />
            )}
            {props.enviarEmail && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="email"
                message="Enviar Email"
                onClick={props.enviarEmail}
              />
            )}
            {props.abrirLinkQR && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="link"
                message="Verificar Transacción en DGII"
                onClick={props.abrirLinkQR}
              />
            )}
            {props.cancelarECF && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="cancel"
                message="Cancelar eCF"
                onClick={props.cancelarECF}
              />
            )}
            {props.reactivar && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="refresh"
                message="Reactivar"
                onClick={props.reactivar}
              />
            )}
            {props.historicoEnvios && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="history"
                message="Histórico de Envíos"
                onClick={props.historicoEnvios}
              />
            )}
            
            {props.facturarAhora && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="send"
                message="Procesar Comprobante Ahora"
                onClick={props.facturarAhora}
              />
            )}
            {props.grabar && (
              <AnimatedIconButton
                size="38px"
                height="24px"
                width="24px"
                iconName="Save"
                message="Guardar"
                onClick={props.grabar}
              />
            )}
          </div>
        </div>
      </Card.Header>
    </div>
  );
}

export default EditHeader;
